import confetti from "canvas-confetti";

function randomInRange(min: number, max: number): number {
  return Math.random() * (max - min) + min;
}

/**
 * Interface for confetti options.
 */
interface ConfettiOptions extends confetti.Options {
  particleCount?: number;
  spread?: number;
  origin?: { y: number };
}

/**
 * Triggers a confetti burst with MUUUH! brand colors.
 * Brand colors: Yellow (#ccff00), Purple (#9747ff), Purple Dark (#53039b)
 *
 * @param options - Optional override for confetti settings
 */
export const triggerBrandConfetti = (options: ConfettiOptions = {}) => {
  const defaults = {
    angle: randomInRange(55, 125),
    spread: randomInRange(50, 70),
    particleCount: randomInRange(90, 150),
    origin: { y: 0.6 },
    colors: ["#ccff00", "#9747ff", "#53039b"],
  };

  confetti({
    ...defaults,
    ...options,
  });
};

/**
 * Triggers a 4s side confetti animation from both sides.
 *
 * @param durationMs - Animation duration in milliseconds
 */
export const triggerSideConfetti = (durationMs = 4000) => {
  const end = Date.now() + durationMs;
  const colors = ["#ccff00", "#9747ff", "#53039b"];

  (function frame() {
    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: colors,
    });
    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: colors,
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  })();
};
